import { render, staticRenderFns } from "./Codebook.vue?vue&type=template&id=d85a64ee&"
import script from "./Codebook.vue?vue&type=script&lang=js&"
export * from "./Codebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports